import CopyButton from "../ui/button/copyButton";
import { Wallet } from "./types";

const WalletCard = ({
  wallet,
  onClick,
}: {
  wallet: Wallet;
  onClick?: () => void;
}) => {
  return (
    <div
       onClick={onClick}
      className="cursor-pointer rounded-2xl border border-gray-200 bg-white p-5
        shadow-sm transition hover:shadow-md hover:border-primary/20
        dark:border-gray-800 dark:bg-white/[0.03] dark:hover:border-primary/30"
    >
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {wallet.flag && (
            <img
              src={wallet.flag}
              alt={wallet.currency}
              className="h-5 w-5 rounded-full"
            />
          )}
          <span className="text-sm font-medium text-gray-800 dark:text-white/90">
            {wallet.name} Wallet ( <span
          className={`text-xs font-medium ${
            wallet.status === "ACTIVE"
              ? "text-green-600"
              : "text-red-500"
          }`}
        >
          {wallet.status}
        </span> )
          </span>
        </div>

       <span className="inline-flex items-center gap-2 text-sm font-medium text-gray-900 dark:text-white">
  {wallet.hasBankAccount && (
    <>
      <span>{wallet.bankDetails?.accountNumber}</span>
      <CopyButton text={wallet.bankDetails?.accountNumber || ""} />
    </>
  )}
</span>

      </div>

      <div className="mb-1 text-2xl font-bold text-gray-900 dark:text-white">
        {wallet.symbol} {wallet.balance.toLocaleString()}
      </div>

      <div className="text-sm text-gray-500 dark:text-gray-400">
        held balance: {wallet.symbol} {wallet.heldBalance.toLocaleString()}
      </div>
    </div>
  );
};

export default WalletCard;
